module.exports = __webpack_public_path__ + "static/media/downArrow.28ad9cdb.svg";